"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavedJobPostingSchema = void 0;
const zod_1 = __importDefault(require("zod"));
exports.SavedJobPostingSchema = zod_1.default.object({
    candidateId: zod_1.default.string(),
    jobPostingId: zod_1.default.string(),
    createdAt: zod_1.default.string().datetime(),
});
